import handleInputChange from '../function/HandleInputsChange';
import InitInput from '../function/InitInput';
import resultToInputs from '../function/resultToInputs';
import { getTreeStructure } from '../treeStructure';

function OptionValue(
  inputs,
  setInputs,
  options,
  setOptions,
  focusedInput,
  result
) {
  const resolvedTreeStructure = getTreeStructure(inputs.sv_family);

  const valueSelect = (option) => {
    let converted = false;

    const dictListToStringList = (list) => {
      try {
        return list.map((item) => {
          if (
            typeof item === 'object' &&
            item !== null &&
            !Array.isArray(item)
          ) {
            converted = true;
            return Object.values(item).join('/');
          }
          return item;
        });
      } catch (e) {
        console.error(e, list);
      }
    };

    const stringToDict = (str) => {
      const values = str.split('/');
      return values.reduce((acc, value, index) => {
        acc[index + 1] = value;
        return acc;
      }, {});
    };

    let value = () => {
      let res = ['select an option'];
      if (option.options.length === 1) {
        handleOptionSelection(option.options[0]);
        res = option.options;
      } else if (
        ![null, undefined].includes(inputs[option.field]) &&
        option.options.some((opt) =>
          typeof inputs[option.field] !== 'object'
            ? String(opt) === String(inputs[option.field])
            : Object.keys(inputs[option.field]).every(
                (key) => String(opt[key]) === String(inputs[option.field][key])
              )
        )
      ) {
        res = [inputs[option.field]];
      } else if (![null, undefined].includes(option.default)) {
        handleOptionSelection(option.default);
        res = [option.default];
      } else if (![null, undefined].includes(inputs[option.field])) {
        handleOptionSelection(null);
      }
      return dictListToStringList(res)[0];
    };

    const handleOptionSelection = (value) => {
      if (converted && typeof value === 'string') {
        handleInputChange(
          option.field,
          stringToDict(value),
          inputs,
          setInputs,
          setOptions
        );
      } else {
        handleInputChange(option.field, value, inputs, setInputs, setOptions);
      }
    };

    return value();
  };

  const calculateValue = (option) => {
    let value;
    if (
      !inputs[option.field] &&
      focusedInput !== option.field &&
      option.auto_positive
    ) {
      const auto_positive_field = result?.[option.auto_positive];
      value =
        typeof auto_positive_field === 'object' && auto_positive_field !== null
          ? Object.values(auto_positive_field).some((subValue) =>
              Boolean(subValue)
            )
          : auto_positive_field;
      if (value !== inputs[option.field])
        handleInputChange(option.field, value, inputs, setInputs, setOptions);
    } else if (
      ![null, undefined].includes(inputs[option.field]) ||
      focusedInput === option.field
    ) {
      value = inputs[option.field];
    } else if (![null, undefined].includes(option.default)) {
      handleInputChange(
        option.field,
        option.default,
        inputs,
        setInputs,
        setOptions
      );
      value = option.default;
    } else {
      value = '';
    }
    return value;
  };

  const trackValue = (option) => {
    const nbr_track = inputs['track'] ? Object.keys(inputs['track']).length : 0;

    const valueToDict = (value) => {
      const obj = {};
      for (let i = 1; i <= nbr_track; i++) {
        obj[i] = value;
      }
      return obj;
    };

    const handleOptionSelection = (value) => {
      const obj = valueToDict(value);
      handleInputChange(option.field, obj, inputs, setInputs, setOptions);
      return obj;
    };

    let res = 'select an option';
    if (option.options.length === 1) {
      res = handleOptionSelection(option.options[0]);
    } else if (
      inputs[option.field] &&
      Object.keys(inputs[option.field]).length === nbr_track &&
      Object.values(inputs[option.field]).every(
        (value) => ![null, 'select an option', undefined, ''].includes(value)
      ) &&
      option.options.some((opt) =>
        Object.values(inputs[option.field]).includes(opt)
      )
    ) {
      res = inputs[option.field];
    } else if (![null, 0, undefined].includes(option.default)) {
      res = handleOptionSelection(option.default);
    } else {
      res = handleOptionSelection('select an option');
    }
    return res;
  };

  const trackTypeDict = resolvedTreeStructure['Optimize']['Flow'].find(
    (item) => typeof item === 'object' && item.hasOwnProperty('track_type')
  );
  const trackTypeContent = trackTypeDict ? trackTypeDict.track_type : [];

  const newOptionObject = options.map((option) => {
    if (option.calculated === true) {
      if (!resultToInputs.includes(option.field)) {
        const initValue = InitInput[option.field];
        handleInputChange(
          option.field,
          initValue,
          inputs,
          setInputs,
          setOptions
        );
      }
      return option;
    } else {
      let value;
      if (trackTypeContent.includes(option.field)) {
        value = trackValue(option);
      } else if (option.input === 'select') {
        value = valueSelect(option);
      } else {
        value = calculateValue(option);
      }
      return { ...option, value };
    }
  });

  const optionFieldList = new Set(options.map((item) => item.field));
  Object.keys(inputs)
    .filter((key) => !optionFieldList.has(key) && key !== 'crm_info')
    .forEach((key) => {
      const initValue = InitInput[key];
      handleInputChange(key, initValue, inputs, setInputs, setOptions);
    });

  return newOptionObject;
}

export default OptionValue;
